import React from 'react';
import { Link } from 'react-router-dom';
import './Service.scss';

const Service = ({serviceList}) => {
    const {title, description, icon, category} = serviceList;
    return (
        <article className="service-box">
            <div className="service-icon">
                <div className='icon-area'>
                    <img src={icon} alt={title} className="service-img-block" />
                </div>
            </div>
            <div className="service-text">
                <h3>
                    <Link to="/singleservice" aria-label={`Learn more about ${title} dental service in Ottery, Cape Town`}>
                        {title}
                    </Link>
                </h3>
                <p>{description}</p>
                {category && (
                    <span className="service-category" aria-label={`Service category: ${category}`}>
                        {category}
                    </span>
                )}
            </div>
        </article>
    );
};

export default Service;